import { useOutletContext, useParams } from "react-router-dom";
import { useAuth } from "hooks/useAuth";

/**
 * The user's role in a workspace, from the workspace list (each entry has a
 * `role`: "admin" or "coach"). Superadmins count as admins everywhere.
 *
 * The API enforces the same rules; this only decides which buttons to show.
 */
export const workspaceRole = (workspaces, workspaceId, user) => {
  const isSuperAdmin = user?.is_superadmin === true;
  const workspace = (workspaces || []).find(
    (w) => String(w.id) === String(workspaceId)
  );
  const role = workspace?.role ?? null;
  return { role, isSuperAdmin, isAdmin: isSuperAdmin || role === "admin" };
};

export default function useWorkspaceRole(workspaceId) {
  const params = useParams();
  const { workspaces } = useOutletContext() || {};
  const { user } = useAuth();
  return workspaceRole(workspaces, workspaceId ?? params.workspaceId, user);
}
